import { FC } from "react";
import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import NavBar from "../layout/NavBar";

const { Content } = Layout;

const DropoffLayout: FC = () => {
  return (
    <Layout style={{ minHeight: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center" }}>
      <Layout>
        <NavBar />
        <Content style={{ width: "100%",
          maxWidth: "1200px",
          padding: "16px" }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default DropoffLayout;
